import { useSelector } from 'react-redux'
import { useCallback } from 'react'
import { renderValue } from '@utils/numberUtils'

export function useRenderValue() {
  const conventions = useSelector((state) => state.conventions)

  return useCallback(
    (value, options = {}) => {
      if (value === null || value === undefined) return ''
      return renderValue({ value, conventions, options })
    },
    [conventions]
  )
}
